<template>
  <div class="excellentcases">

    <headerview :cur="4"></headerview>

    <div class="content">

      <div class="moddlecon w13">
        <div class="tipcon">
          
          <tipconNav :title="tipName" :name="[{label:'下载专区',url:'/studytrain'},{label:tipName,url:'/downloadlist?signtype=6'}]" :imgtype="'5'" width="2.05"></tipconNav>
        </div>

        <div class="listcon min-h">
          <div class="signle" v-for="(item,index) in list" :key="index">
            <div class="title overfh" @click="goDetail(item)" v-if='signtype == 6' :title="item.compilationTitle">{{ item.compilationTitle }}</div>
            <div class="title overfh" v-else :title="item.title">{{ item.title }}</div>
            <div class="time" @click.stop="downloadFile(item)">
              点击下载
              <div class="imgcon"></div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="">
          <div is='footPage' class="zhini-pagination"
               :currentPage="pageNo"
               :totalPage="total"
               @pageNum="pageNum"  :pagesize='pageSize'></div>
        </div>

      </div>

    </div>

    <footview></footview>

  </div>

</template>

<script>
import footPage from '../../../components/footpage/footpage.vue'

export default {
  components: {
    footPage,
  },
  data: function () {
    return {
      list: [],
      pageNo: 1,
      total: 1,
      pageSize: 8,
      signtype: '',
      tipName: '政策文件',
    };
  },

  mounted() {
    this.$onScrollT()
    this.getCulturallist()
  },

  methods: {
    goDetail(item){
      this.$router.push({path:'/downloadDetailbox',query:{id:item.id}})
    },
    getCulturallist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      var getUrl='/web/download/list'
      if (this.$route.query) {
        this.signtype = this.$route.query.signtype;
        if (this.signtype == '4') {
          this.tipName = '政策文件'
          params.regionType = 0

        } else if (this.signtype == '5') {
          this.tipName = '优秀案例/课件'
          params.regionType = 1
        } else if (this.signtype == '6') {
          this.tipName = '证书模板'
          params.studyType = 4
          getUrl='/web/info/studyData'
        } else if (this.signtype == '7') {
          this.tipName = '音/视频资料'
          params.regionType = 3
        }
      }
      this.$get(getUrl, params).then(res => {
        if (res.success) {
          this.list = res.result.records
          this.total = res.result.total
        }
      })
    },
    downloadFile(item) {
      // if(item.uploadType==1){
			// 	window.open(item.uploadHref)
			// }else{ 
			// 	window.open(this.$imgUrl + item.fileId_dictText)
			// }
      if(item.fileId_dictText||item.uploadType==1){ 
        if(item.uploadType==1){ 
          window.open(item.uploadHref)
        }else{ 
          window.open(this.$imgUrl + item.fileId_dictText)
        }
        
      }else{
        this.$message.success('没有附件')
      }
    },
    pageNum(e) {
      this.pageNo = e;
      this.$onScrollT()
      this.getCulturallist()
    }


  },


};
</script>

<style scoped="scoped" lang="scss">

.excellentcases {

  .content {
    display: flex;
    justify-content: center;

    .moddlecon {
      background-color: #FFFFFF;
      padding: 20px 50px 0px 50px;
			box-sizing: border-box;

      .listcon {
        .signle {
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px dashed #ededed;

          .title {
            cursor: pointer;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            width: calc(100% - 150px);
          }

          .time {
            display: flex;
            cursor: pointer;
            font-size: 18px;
            font-weight: 400;
            color: #999999;

            .imgcon {
              margin-left: 10px;
              width: 27px;
              height: 17px;
              background: url(../../../static/img/downz.png) no-repeat top center/ 100% 100%;
            }
          }
        }

        .signle:hover .title {
          color: #E61F26;
        }

        .signle:hover .time {
          color: #E61F26;
        }

        .signle:hover .imgcon {
          background: url(../../../static/img/downzcur.png) no-repeat top center/ 100% 100%;
        }

      }


    }

  }


}

</style>
